﻿import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import { UPDATE_ESTATES_PARENTS_ESTATES } from "@/redux/types/auth.types";
import { useEstatesParentsPaginate, useMutateEstatesParent, useMutateDeleteEstatesParent } from "@/hooks/maintainers/estatesParents";
import { hasPermission } from "@/services/Utils";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import EstatesParentsTableBody from "./EstatesParentsTableBody";
import EstatesParentsForm from "./EstatesParentsForm/EstatesParentsForm";

import { base_list } from "./estatesparents.constants";
import EstatesParentsTableHead from "./EstatesParentsTableHead";

import classes from "../maintainers.module.scss";

const EstatesParents = () => {
	const { addToast } = useToasts();
	const { search, estate_parent_id } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [selected, setSelected] = useState("");

	const { data, isLoading, isFetching } = useEstatesParentsPaginate({
		...base,
		search,
		estate_parent_id,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateEstatesParent({
		...base,
		search,
		estate_parent_id,
	});
	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteEstatesParent({
		...base,
		search,
		estate_parent_id,
	});

	const { estates_parents: list, permissions, estates, regions } = data || {};
	const { data: estates_parents, last_page, total, from, to } = list || {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, estate_parent_id, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					addToast(`El Campo se eliminó correctamente.`, {
						appearance: "success",
					});
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, estate_parent_id, params: { ...data } },
			{
				onSuccess: (response) => {
					const { estates, estates_parents } = response ? response.user : {};
					if (estates) {
						dispatch({
							type: UPDATE_ESTATES_PARENTS_ESTATES,
							payload: {
								estates_parents: estates_parents,
								estates: estates,
							},
						});
					}

					addToast(`El Campo se guardó correctamente.`, {
						appearance: "success",
					});
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading || isLoadingDelete) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title={"Campos"}
				button={hasPermission("create", permissions) ? true : false}
				button_text={`Añadir Campos`}
				action={() => navigate("/configuracion/grupos_campos/crear")}
				back_url={"/configuracion?section=general"}
				isFetching={isFetching}
			/>

			{hasPermission("show", permissions) && (
				<Row className={` ${classes.main_row}`}>
					<Col md={12} className={classes.main_col}>
						<Row className={classes.table}>
							<div className={classes.table_div}>
								<Table className={classes.table_desktop}>
									<EstatesParentsTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />

									<EstatesParentsTableBody
										estates_parents={estates_parents}
										handleDelete={handleDelete}
										permissions={permissions}
										estates={estates}
										regions={regions}
									/>
								</Table>
							</div>
						</Row>

						<BasePagination
							page={base.page}
							paginate={base.paginate}
							last_page={last_page}
							quantity={total}
							from={from}
							to={to}
							setPage={setPage}
							setPaginate={setPaginate}
						/>
					</Col>
				</Row>
			)}

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={`eliminar campo`}
			/>

			{option && (
				<EstatesParentsForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} permissions={permissions} estates={estates} regions={regions} />
			)}
		</>
	);
};

export default EstatesParents;
